var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":""}},[_c('div',{staticClass:"g-link-clear button-create"},[_c('span',[_vm._v(_vm._s(_vm.$t("nav.signup")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }